import { FC, ReactElement, SyntheticEvent, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { registerRequest } from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import { RegisterForm, RegisterFormValues } from './register-form'
// import { RequestError } from 'src/interfaces'

interface RegisterProps {
  isLanding: boolean
}

export const Register: FC<RegisterProps> = ({ isLanding = false }): ReactElement => {
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string>('')

  const handleLoginLink = (e: SyntheticEvent) => {
    e.preventDefault()
    history.push(routes.login)
  }

  const handleSubmit = async (data: RegisterFormValues) => {
    try {
      setIsLoading(true)
      setError('')
      await registerRequest(data)
      history.replace('/confirmation-link-sent', { email: data.email })
    } catch (err) {
      setError(err.response.data?.error[0])
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <RegisterForm
      error={error}
      isLanding={isLanding}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      handleLoginLink={handleLoginLink}
    />
  )
}
